import { LlmHistoryNode } from '@adaptiva/ai/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'adaIsInLlmFork'
})
export class IsInLlmForkPipe implements PipeTransform {

	public transform(
		_node: LlmHistoryNode | null,
		_forkId: string,
		_nodes: Map<string, LlmHistoryNode>
	): boolean {
		if (_node == null)
			return false;

		if (!_forkId)
			return false;

		if (_node.nodeId === _forkId)
			return true;

		const _fork: LlmHistoryNode | undefined = _nodes.get(_forkId);

		if (!_fork)
			return false;

		let _parent: LlmHistoryNode | undefined = _fork.parent;

		while (_parent) {
			if (_node.nodeId === _parent.nodeId)
				return true;

			_parent = _parent.parent;
		}

		return false;
	}

}
